import { render, staticRenderFns } from "./Productadd.vue?vue&type=template&id=90d0894c&"
import script from "./Productadd.vue?vue&type=script&lang=js&"
export * from "./Productadd.vue?vue&type=script&lang=js&"
import style0 from "./Productadd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports